/* Que Linda theme — minimal interactions */
(function () {
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-nav-toggle]');
    if (t) {
      var nav = document.getElementById('MobileNav');
      if (nav) nav.classList.toggle('open');
    }
  });

  // Quantity steppers on product page
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input[name="quantity"]');
    if (!input) return;
    var val = parseInt(input.value || '1', 10);
    val += btn.getAttribute('data-qty') === 'up' ? 1 : -1;
    if (val < 1) val = 1;
    input.value = val;
  });

  // Refresh cart count from Shopify Ajax API
  function updateCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = c.item_count;
          el.style.display = c.item_count > 0 ? '' : 'none';
        });
      }).catch(function () {});
  }
  document.addEventListener('DOMContentLoaded', updateCart);

  // Simple gallery thumbnail swap
  document.addEventListener('click', function (e) {
    var th = e.target.closest('[data-thumb]');
    if (!th) return;
    var main = document.querySelector('[data-main-image]');
    if (main) main.src = th.getAttribute('data-thumb');
  });
})();
